import { PositionFormatter } from '../../cache/Formatters/PositionFormatter';
import { TvSymbolConvertor } from './TvSymbolConvertor';
class _TvPositionConvertor {
    convertToTvPosition(position) {
        const tvPosition = {
            id: PositionFormatter.PositionId(position),
            symbol: this.getSymbol(position), // ticker ?
            qty: PositionFormatter.Amount(position),
            // shortQty?: number;
            // longQty?: number;
            side: this.getPositionSide(position),
            avgPrice: PositionFormatter.Price(position) // open price ?
            // message?: OrderOrPositionMessage;
        };
        return tvPosition;
    }
    getPositionSide(position) {
        return PositionFormatter.IsLong(position) ? 1 /* Side.Buy */ : -1 /* Side.Sell */;
    }
    getSymbol(position) {
        // const symbol = position.Instrument.DisplayName();
        // return TvInteriorIdCache.getInteriorId(symbol);
        return TvSymbolConvertor.getFullname(position.Instrument);
    }
}
export const TvPositionConvertor = new _TvPositionConvertor();
